import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useWizardComplete from 'Views/Page/Hooks/useWizardComplete';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import FailedToLinkContentWrapper from 'Views/Page/Content/Templates/FailedToLinkTemplate/FailedToLinkContentWrapper';
import {
  onFailedToLinkContentPrimaryAction,
  onFailedToLinkContentSpecificLinkClicked,
} from 'Components/ComponentLibrary/Organisms/FailedToLinkContent/FailedToLinkContent';
import { useHistory } from 'react-router';

const styles = () => ({
  root: {},
});

const FailedToLinkTemplate = ({
  className,
  classes,
  resource,
}) => {
  const { loadPageContentLink } = usePageContentContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const history = useHistory();

  const onPrimaryAction = () => onFailedToLinkContentPrimaryAction(resource, logStandardizedEvent, loadPageContentLink, history);
  const specificLinkClicked = () => onFailedToLinkContentSpecificLinkClicked(resource, logStandardizedEvent, loadPageContentLink);

  const { handleNext } = useWizardComplete(onPrimaryAction);

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={FailedToLinkContentWrapper}
      onNext={handleNext}
      hideBack
      onSpecificLinkClicked={specificLinkClicked}
    />
  );
};

FailedToLinkTemplate.defaultProps = {
  className: '',
};

FailedToLinkTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(FailedToLinkTemplate);
